import { TextInputField } from "evergreen-ui";
import React from "react";
import Button from "src/Components/Button";
import Logo from "src/Components/Logo";
import Loader from "src/Components/Loader";
import { InputHooksType } from "src/Types/data-types";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: ${(props) => props.theme.auth};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const ContainerOverlay = styled.div`
  display: flex;
  height: 100%;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  padding: 20px;
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.2);

  @media (max-width: ${(props) => props.theme.screenWidth}) {
    min-height: 100vh;
    padding: 0px;
  }
`;

const BigBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 70vh;
  min-height: 70vh;
  background-color: white;
  max-width: 820px;
  border-radius: 40px;
  overflow: hidden;
  @media (max-width: ${(props) => props.theme.screenWidth}) {
    height: 100%;
    max-height: none;
    flex-direction: column;
    border-radius: 0px;
  }
`;

const ImgBox = styled.div`
  display: flex;
  background: ${(props) => props.theme.auth};
  height: 100%;
  width: 100%;
  min-height: 60vh;
  background-position: center;
  background-size: cover;
  @media (max-width: ${(props) => props.theme.screenWidth}) {
    height: 40vh;
    min-height: 40vh;
  }
`;

const Form = styled.div`
  height: 100%;
  display: flex;
  width: 100%;
  position: relative;
  padding: 20px;
  justify-content: space-between;
  flex-direction: column;
  overflow-y: auto;
  @media (max-width: ${(props) => props.theme.screenWidth}) {
    height: 100%;
    padding-bottom: 20px;
  }
`;

const FormFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const Title = styled.h1`
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
`;

const UnderlinedText = styled.span`
  text-decoration: underline;
  cursor: pointer;
  :hover {
    opacity: 0.7;
  }
  color: ${(props) => props.theme.accentColor};
`;

const LoadingWrapper = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
`;
const Space = styled.div`
  width: 100%;
  text-align: center;
  padding: 1rem;
`;

const MobileLogo = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 1rem;
  align-items: center;
  justify-content: center;
`;
interface IProps {
  isLoading: boolean;
  signInForm: boolean;
  toggleSignInForm: any;
  signIn: any;
  signUpWithEmail: any;
  useGoogle: any;
  signUpEmail: InputHooksType;
  signUpPassword: InputHooksType;
  signInEmail: InputHooksType;
  signInPassword: InputHooksType;
}
const AuthPresenter: React.SFC<IProps> = ({
  isLoading,
  signIn,
  signUpWithEmail,
  useGoogle,
  signUpEmail,
  signUpPassword,
  signInEmail,
  signInPassword,
  signInForm,
  toggleSignInForm,
}) => {
  return (
    <Container>
      <ContainerOverlay>
        <BigBox>
          <ImgBox />
          {signInForm ? (
            <Form>
              <MobileLogo>
                <Logo />
              </MobileLogo>
              {isLoading && (
                <LoadingWrapper>
                  <Loader message="Signing in..." />{" "}
                </LoadingWrapper>
              )}
              <div>
                <Title>Sign In</Title>
                <TextInputField
                  label="E-mail"
                  {...signInEmail}
                  placeholder="your@email.com"
                />
                <TextInputField
                  label="Password"
                  {...signInPassword}
                  placeholder="******"
                  type="password"
                />
                <Button
                  disabled={
                    signInEmail.value === "" || signInPassword.value === ""
                  }
                  onClick={signIn}
                  label="Sign In"
                />
                <Space>
                  <p>
                    <UnderlinedText>Forgot password</UnderlinedText>
                  </p>
                </Space>
              </div>
              <FormFooter>
                Don't have an account? &nbsp;
                <UnderlinedText onClick={toggleSignInForm}>
                  Create account
                </UnderlinedText>
              </FormFooter>
            </Form>
          ) : (
            <Form>
              <MobileLogo>
                <Logo />
              </MobileLogo>
              {isLoading && (
                <LoadingWrapper>
                  <Loader message="Creating account..." />{" "}
                </LoadingWrapper>
              )}
              <div>
                <Title>Create new account</Title>
                <TextInputField
                  placeholder="your@email.com"
                  label="E-mail"
                  {...signUpEmail}
                />
                <TextInputField
                  placeholder="******"
                  label="Password"
                  type="password"
                  {...signUpPassword}
                />
                <Button
                  disabled={
                    signUpEmail.value === "" || signUpPassword.value.length < 6
                  }
                  label="Create Account"
                  onClick={signUpWithEmail}
                />
              </div>
              <FormFooter>
                Already have an account? &nbsp;
                <UnderlinedText onClick={toggleSignInForm}>
                  Sign In
                </UnderlinedText>
              </FormFooter>
            </Form>
          )}
        </BigBox>
      </ContainerOverlay>
    </Container>
  );
};

export default AuthPresenter;
